module.exports = __webpack_public_path__ + "img/pic06.d0bcd4ba.png";